import { createTileLayer } from "lib/leaflet"; 
import { TileLayerOptions } from "leaflet"


export const newTileLayer = (url: string, options: TileLayerOptions) => {
    return createTileLayer(url, options);
}